export default __webpack_public_path__ + "static/media/Brew of Vigorous Aptitude.31108a97.jpg";